const carouselItems = [
  {
    title: '韩漫精选：2024年度必看TOP10',
    desc: '从甜蜜恋爱到悬疑惊悚，布丁漫画编辑团队为你精选年度最佳韩漫，下拉式阅读畅享全集。',
    tag: '韩漫专题',
    image: 'https://readdy.ai/api/search-image?query=Collection%20of%20Korean%20webtoon%20style%20illustrations%20featuring%20romantic%20and%20dramatic%20scenes%2C%20clean%20modern%20digital%20art%2C%20warm%20coral%20and%20amber%20tones%2C%20elegant%20character%20designs%2C%20cinematic%20composition%2C%20high%20quality%20illustration%20for%20comic%20platform%20feature&width=900&height=500&seq=carousel-01&orientation=landscape',
  },
  {
    title: '逆袭爽文漫画大合集',
    desc: '废柴逆袭、重生复仇、都市修仙——最燃的逆袭题材漫画一次看够，从头爽到尾不停歇！',
    tag: '逆袭专题',
    image: 'https://readdy.ai/api/search-image?query=Dynamic%20manga%20illustration%20of%20a%20protagonist%20transforming%20from%20ordinary%20to%20powerful%2C%20action%20scene%20with%20energy%20effects%2C%20clean%20webtoon%20style%2C%20warm%20intense%20coral%20and%20dark%20tones%2C%20cinematic%20lighting%2C%20high%20quality%20digital%20art&width=900&height=500&seq=carousel-02&orientation=landscape',
  },
  {
    title: '国漫崛起：精品国漫推荐',
    desc: '国漫质量持续攀升，布丁漫画精选多部高质量国漫作品，古风、奇幻、现代题材一应俱全。',
    tag: '国漫专题',
    image: 'https://readdy.ai/api/search-image?query=Chinese%20style%20manga%20illustration%20with%20ancient%20Chinese%20aesthetic%2C%20flowing%20ink%20and%20brush%20art%20style%20merged%20with%20modern%20webtoon%2C%20warm%20gold%20and%20coral%20tones%2C%20elegant%20composition%2C%20traditional%20elements%20with%20contemporary%20digital%20art&width=900&height=500&seq=carousel-03&orientation=landscape',
  },
  {
    title: '恋爱漫画甜到齁特辑',
    desc: '霸道总裁、校园初恋、契约恋人……布丁漫画恋爱专区精选最甜的恋爱漫画，每天都是心动时刻。',
    tag: '恋爱专题',
    image: 'https://readdy.ai/api/search-image?query=Romantic%20webtoon%20style%20illustration%20of%20a%20couple%20in%20cherry%20blossom%20setting%2C%20soft%20warm%20lighting%2C%20sweet%20and%20gentle%20atmosphere%2C%20clean%20digital%20art%2C%20coral%20and%20pink%20tones%2C%20dreamy%20composition&width=900&height=500&seq=carousel-04&orientation=landscape',
  },
  {
    title: '新作速递：本周上架新漫一览',
    desc: '布丁漫画每周都有新作上架，下拉式阅读专区首发多部热门漫画，第一时间尝鲜阅读。',
    tag: '新作专题',
    image: 'https://readdy.ai/api/search-image?query=Vibrant%20collection%20of%20diverse%20manga%20characters%20in%20a%20display%20showcase%20style%2C%20fresh%20and%20energetic%2C%20clean%20webtoon%20art%2C%20warm%20coral%20and%20amber%20tones%2C%20modern%20gallery%20presentation%2C%20high%20quality%20digital%20illustration&width=900&height=500&seq=carousel-05&orientation=landscape',
  },
];

export default function CarouselSection() {
  return (
    <section id="carousel" className="py-14 md:py-20 bg-background-50">
      <div className="w-full px-4 md:px-6">
        <div className="max-w-6xl mx-auto">
          <div className="text-center mb-10 md:mb-14">
            <h2 className="text-2xl md:text-3xl font-heading font-bold text-foreground-950 mb-3">
              焦点专题
            </h2>
            <p className="text-sm text-foreground-500 max-w-xl mx-auto">
              布丁漫画为你精心策划的漫画专题合集，发现更多你喜欢的作品
            </p>
          </div>

          <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-5 md:gap-6">
            {carouselItems.map((item, i) => {
              const isLarge = i === 0;
              return (
                <div
                  key={i}
                  className={`group rounded-2xl overflow-hidden bg-background-50 border border-background-200/70 hover:border-primary-200 transition-all duration-300 cursor-pointer ${
                    isLarge ? 'md:col-span-2 lg:col-span-2' : ''
                  }`}
                >
                  <div className={`relative overflow-hidden bg-background-100 ${isLarge ? 'aspect-[16/7]' : 'aspect-[16/9]'}`}>
                    <img
                      src={item.image}
                      alt={`布丁漫画下拉式阅读 - ${item.title}`}
                      className="w-full h-full object-cover group-hover:scale-105 transition-transform duration-500"
                      title={`布丁漫画下拉式看 ${item.tag}`}
                    />
                    <div className="absolute inset-0 bg-gradient-to-t from-background-950/60 via-transparent to-transparent"></div>
                    <div className="absolute bottom-0 left-0 right-0 p-4 md:p-6">
                      <span className="inline-block px-3 py-1 rounded-full bg-accent-500 text-background-50 text-xs font-semibold mb-2 whitespace-nowrap">
                        {item.tag}
                      </span>
                      <h3 className="text-base md:text-lg font-heading font-bold text-background-50 mb-1">
                        {item.title}
                      </h3>
                      <p className="text-xs text-background-200 leading-relaxed line-clamp-2">
                        {item.desc}
                      </p>
                    </div>
                  </div>
                </div>
              );
            })}
          </div>
        </div>
      </div>
    </section>
  );
}